import {inject, Injectable} from '@angular/core';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {signOut} from '@firebase/auth';
import {firstValueFrom} from 'rxjs';
import {FIREBASE_AUTH} from '../app/config/module.di.tokens';

@Injectable({
  providedIn: 'root'
})
export class LeadService {
  private indexedDb = inject(NgxIndexedDBService);
  private auth = inject(FIREBASE_AUTH)

  async clearLeads() {
    await signOut(this.auth)
    await firstValueFrom(this.indexedDb.clear('leads'))
  }
}
